/**
 * WebAction otevira zvolenou cast accorionu ostatni zavre (skryje).
 * Po otevreni odscrolluje na zacatek zvoleneho bloku
 */
import 'element-closest';

export default (props, e) => {
	e.stopPropagation();
	const {
		actionClass,
		actionTarget,
		separator = ';',
		headerHeight = 66,
	} = props;
	const { target } = e;

	if ( actionTarget ) {
		const targetSet = actionTarget.split(separator);
		targetSet.forEach(element => [ ...document.querySelectorAll(element) ].forEach( (elm) => {
			elm.classList.remove(actionClass);
			target.closest(element).classList.add(actionClass);
			const tabScroll = target.closest(element).getBoundingClientRect().top;
			const topPos = (tabScroll + window.pageYOffset) - headerHeight;
			// clog([clickedTab.getBoundingClientRect().top, window.pageYOffset, topPos, this.props.headerHeight]);
			window.scroll({ top: topPos, left: 0, behavior: 'smooth' });
		}));
	}
};



// WEBPACK FOOTER //
// ./fe/web-majetek/src/js/webActions/switchAccordion.js